"use strict";
var Ray_1 = require('../../../utils/Ray');
/**
 * {@code RayConfigurationBase} is the base class for concrete ray configurations having a fixed number of rays.
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var RayConfigurationBase = (function () {
    /**
     * Creates a {@code RayConfigurationBase} for the given owner and the specified number of rays.
     * @param owner the owner of this configuration
     * @param numRays the number of rays used by this configuration
     */
    function RayConfigurationBase(owner, numRays) {
        this.owner = owner;
        this.rays = [];
        for (var i = 0; i < numRays; i++)
            this.rays.push(new Ray_1.default(owner.getPosition().clone().setZero(), owner.getPosition().clone().setZero()));
    }
    /** Returns the owner of this configuration. */
    RayConfigurationBase.prototype.getOwner = function () {
        return this.owner;
    };
    /** Sets the owner of this configuration. */
    RayConfigurationBase.prototype.setOwner = function (owner) {
        this.owner = owner;
    };
    /** Returns the rays of this configuration. */
    RayConfigurationBase.prototype.getRays = function () {
        return this.rays;
    };
    /** Sets the rays of this configuration. */
    RayConfigurationBase.prototype.setRays = function (rays) {
        this.rays = rays;
    };
    return RayConfigurationBase;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RayConfigurationBase;
//# sourceMappingURL=RayConfigurationBase.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/steer/utils/rays/RayConfigurationBase.js
 ** module id = 900
 ** module chunks = 0
 **/